import { render } from "./Q8Detaillee.vue?vue&type=template&id=45edff3a"
import script from "./Q8Detaillee.vue?vue&type=script&lang=js"
export * from "./Q8Detaillee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__